// extracted by mini-css-extract-plugin
export default {"card":"ClubCard_card__SZuC0","card__title":"ClubCard_card__title__y1izC","card__img":"ClubCard_card__img__PGLrl","card__btn":"ClubCard_card__btn__FF15t"};